import { getCsrfValue } from "../../../api/ApiHelper";

import { resolveApiUrl } from "../../../utils/url/urlResolver";

export function apiDeleteSavedConfig(configCode: string): Promise<boolean> {
  const apiUrl = resolveApiUrl(`/saved-configs/${configCode}`);

  return fetch(apiUrl, {
    cache: "no-cache",
    credentials: "same-origin",
    method: "DELETE",
    mode: "cors",
    headers: {
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  })
    .then((result) => {
      if (result.ok) {
        return true;
      } else {
        console.error(`Error sending linear update: ${result.status}`);
        return false;
      }
    })
    .catch((err) => {
      console.error(err);
      return false;
    });
}
